export enum LiningWeight {
  Blackout = "Blackout",
  Standard = "Standard",
}

export enum StackingStyle {
  Waterfall = "Waterfall",
  SelfStack = "Self Stack",
}

export enum HeadingType {
  PencilPleat = "Pencil pleat",
  DoublePinch = "Double pinch pleat",
  TriplePleat = "Triple pinch pleat",
  Eyelet = "Eyelet",
}

export type RomanBlindConfiguration = {
  type: "RomanBlind";
  stackingStyle: StackingStyle;
  width: number;
  height: number;
  installationHeight: number;
  liningWeight: LiningWeight;
  liningColour: string;
  controlSide: string;
};

export type CurtainConfiguration = {
  type: "Curtain";
  headingType: HeadingType;
  lengthOfTrackOrPole: number;
  eyeDrop: number;
  liningWeight: LiningWeight;
  liningColour: string;
  eyeletColour?: string;
  typeOfCurtain: string;
};

export type MadeToMeasureConfiguration =
  RomanBlindConfiguration | CurtainConfiguration;
